module.exports = __webpack_public_path__ + "img/54.9c79d68d.jpg";